import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Cookies } from '../../../index.js';
import { alert_error, alert_success } from "../../../AppContext.js";
import { BarLoader } from "react-spinners";
import PartnerProfile from "../../../community/profile/partner_profile.jsx";

const History = () => {
    const [items, setItems] = useState(null);
    const [activeInfoId, setActiveInfoId] = useState(null);
    const [actionLoading, setActionLoading] = useState(null);

    const handleApproval = async (item, status) => {
        const apikey = Cookies.get('apikey');
        const idCashApproval = item.id_cash_approval;

        if (!apikey) {
            alert_error('Vui lòng đăng nhập lại');
            return;
        }
        if (!idCashApproval) {
            alert_error('Thiếu mã đơn cần duyệt');
            return;
        }

        const loadingKey = `${idCashApproval}-${status}`;
        setActionLoading(loadingKey);
        try {
            const response = await axios.get('https://hust.media/jop/mission/mode_p2p/history_accept.php', {
                params: {
                    apikey,
                    status,
                    id_cash_approval: idCashApproval
                }
            });
            if (response?.data?.status == 1) {
                alert_success(response?.data?.message || 'Thành công');
                fetchItems();
            } else {
                alert_error(response?.data?.message || 'Thất bại');
            }
        } catch (error) {
            console.log(error);
            alert_error('Có lỗi xảy ra');
        } finally {
            setActionLoading(null);
        }
    };

    const fetchItems = () => {
        const apikey = Cookies.get('apikey');
        const params = apikey ? { apikey, mode: 'approve' } : undefined;

        axios
            .get('https://hust.media/jop/mission/mode_p2p/history_lists.php', { params })
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                setItems(data);
            })
            .catch((error) => {
                console.log(error);
                setItems([]);
            });
    };

    useEffect(() => {
        fetchItems();
    }, []);

    if (!items) {
        return (
            <div className="mt-4 flex justify-center items-center">
                <BarLoader size={50} color="#003AA5" />
            </div>
        );
    }

    return (
        <div className="p-2">
            {items.length === 0 ? (
                <div className="text-center text-lg font-semibold text-gray-700">
                    Không có dữ liệu
                </div>
            ) : (
                <div className="grid gap-4">
                    {items.map((item) => {
                        const rowId = item.id_cash_approval || item.url_videos;
                        const partnerUsername = item.username || '';
                        const showInfo = activeInfoId === rowId && partnerUsername;
                        const idCashApproval = item.id_cash_approval;

                        return (
                        <div
                            key={rowId}
                            className="rounded-lg border bg-white p-3 shadow-sm"
                        >
                            <div className="mb-2 flex flex-wrap items-center justify-between gap-2 text-sm">
                                <div className="font-semibold">{item.username || 'No name'}</div>
                                <div className="text-xs text-gray-700">{item.status}</div>
                                <div className="text-xs text-gray-600">{item.createdate}</div>
                            </div>
                            {item.url_videos && (
                                <div className="mb-2">
                                    {item.category_code === "p2p_mmo_video" ? (
                                        <video
                                            className="w-full max-h-[360px] rounded"
                                            controls
                                            src={item.url_videos}
                                        />
                                    ) : (
                                        <img
                                            src={item.url_videos}
                                            alt="media"
                                            className="w-full max-h-[360px] rounded object-contain"
                                        />
                                    )}
                                </div>
                            )}
                            {item.note && (
                                <div className="mb-1 text-sm text-gray-700">{item.note}</div>
                            )}
                            {Array.isArray(item.worker) && item.worker.length > 0 && (
                                <div className="mb-1 text-base text-gray-700 whitespace-pre-line text-center">
                                    {item.worker
                                        .map((entry) => entry?.comments_orders)
                                        .filter(Boolean)
                                        .join("\n")}
                                </div>
                            )}
                            <div className="mt-2 flex gap-2">
                                <button
                                    type="button"
                                    disabled={!idCashApproval || actionLoading === `${idCashApproval}-Canceled`}
                                    onClick={() => handleApproval(item, 'Canceled')}
                                    className="rounded bg-red-200 px-3 py-1 text-sm font-semibold text-red-700"
                                >
                                    Không duyệt
                                    {actionLoading === `${idCashApproval}-Canceled` && (
                                        <span className="spinner-border spinner-border-sm ml-2" role="status" />
                                    )}
                                </button>
                                <button
                                    type="button"
                                    disabled={!idCashApproval || actionLoading === `${idCashApproval}-Completed`}
                                    onClick={() => handleApproval(item, 'Completed')}
                                    className="rounded bg-green-200 px-3 py-1 text-sm font-semibold text-green-700"
                                >
                                    Duyệt media
                                    {actionLoading === `${idCashApproval}-Completed` && (
                                        <span className="spinner-border spinner-border-sm ml-2" role="status" />
                                    )}
                                </button>
                                <button
                                    type="button"
                                    disabled={!partnerUsername}
                                    onClick={() =>
                                        setActiveInfoId((current) => (current === rowId ? null : rowId))
                                    }
                                    className="rounded bg-blue-200 px-3 py-1 text-sm font-semibold text-blue-700 disabled:opacity-50"
                                >
                                    {showInfo ? "Thông tin x" : "Thông tin"}
                                </button>
                            </div>

                            {showInfo && (
                                <div className="mt-3">
                                    <PartnerProfile partnerUsername={partnerUsername} />
                                </div>
                            )}
                        </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default History;
